/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganizationAdminDto,
  CreateOrganizationUserDto,
  ProblemDetails,
  UserWithRolesDto,
} from '../models/index';
import {
    CreateOrganizationAdminDtoFromJSON,
    CreateOrganizationAdminDtoToJSON,
    CreateOrganizationUserDtoFromJSON,
    CreateOrganizationUserDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UserWithRolesDtoFromJSON,
    UserWithRolesDtoToJSON,
} from '../models/index';

export interface UsersAdminCreateOrganizationAdminPOSTRequest {
    createOrganizationAdminDto?: CreateOrganizationAdminDto;
}

export interface UsersAdminCreateOrganizationUserPOSTRequest {
    createOrganizationUserDto?: CreateOrganizationUserDto;
}

/**
 * UsersAdminApi - interface
 * 
 * @export
 * @interface UsersAdminApiInterface
 */
export interface UsersAdminApiInterface {
    /**
     * Creates request options for usersAdminCreateOrganizationAdminPOST without sending the request
     * @param {CreateOrganizationAdminDto} [createOrganizationAdminDto] 
     * @throws {RequiredError}
     * @memberof UsersAdminApiInterface
     */
    usersAdminCreateOrganizationAdminPOSTRequestOpts(requestParameters: UsersAdminCreateOrganizationAdminPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CreateOrganizationAdminDto} [createOrganizationAdminDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApiInterface
     */
    usersAdminCreateOrganizationAdminPOSTRaw(requestParameters: UsersAdminCreateOrganizationAdminPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>>;

    /**
     */
    usersAdminCreateOrganizationAdminPOST(requestParameters: UsersAdminCreateOrganizationAdminPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto>;

    /**
     * Creates request options for usersAdminCreateOrganizationUserPOST without sending the request
     * @param {CreateOrganizationUserDto} [createOrganizationUserDto] 
     * @throws {RequiredError}
     * @memberof UsersAdminApiInterface
     */
    usersAdminCreateOrganizationUserPOSTRequestOpts(requestParameters: UsersAdminCreateOrganizationUserPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CreateOrganizationUserDto} [createOrganizationUserDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApiInterface
     */
    usersAdminCreateOrganizationUserPOSTRaw(requestParameters: UsersAdminCreateOrganizationUserPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>>;

    /**
     */
    usersAdminCreateOrganizationUserPOST(requestParameters: UsersAdminCreateOrganizationUserPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto>;

}

/**
 * 
 */
export class UsersAdminApi extends runtime.BaseAPI implements UsersAdminApiInterface {

    /**
     * Creates request options for usersAdminCreateOrganizationAdminPOST without sending the request
     */
    async usersAdminCreateOrganizationAdminPOSTRequestOpts(requestParameters: UsersAdminCreateOrganizationAdminPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/UsersAdmin/organization-admins`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationAdminDtoToJSON(requestParameters['createOrganizationAdminDto']),
        };
    }

    /**
     */
    async usersAdminCreateOrganizationAdminPOSTRaw(requestParameters: UsersAdminCreateOrganizationAdminPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>> {
        const requestOptions = await this.usersAdminCreateOrganizationAdminPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoFromJSON(jsonValue));
    }

    /**
     */
    async usersAdminCreateOrganizationAdminPOST(requestParameters: UsersAdminCreateOrganizationAdminPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto> {
        const response = await this.usersAdminCreateOrganizationAdminPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersAdminCreateOrganizationUserPOST without sending the request
     */
    async usersAdminCreateOrganizationUserPOSTRequestOpts(requestParameters: UsersAdminCreateOrganizationUserPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/UsersAdmin/organization-users`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationUserDtoToJSON(requestParameters['createOrganizationUserDto']),
        };
    }

    /**
     */
    async usersAdminCreateOrganizationUserPOSTRaw(requestParameters: UsersAdminCreateOrganizationUserPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>> {
        const requestOptions = await this.usersAdminCreateOrganizationUserPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoFromJSON(jsonValue));
    }

    /**
     */
    async usersAdminCreateOrganizationUserPOST(requestParameters: UsersAdminCreateOrganizationUserPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto> {
        const response = await this.usersAdminCreateOrganizationUserPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
